import React from 'react'
import LeftPanel from '../components/LeftPanel'
import RightSide from '../components/RightSide'

const Page3 = () => {
  return (
    <>
      <LeftPanel />
      <RightSide />
    </>
  )
}

export default Page3
